import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 提交按钮 */
const SubmitButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

SubmitButton.defaultProps = {
  icon: ICON_COLLECTION.SUBMIT,
  text: '提交',
};

export default SubmitButton;
